/* import __COLOCATED_TEMPLATE__ from './company-billing-contact.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-company-billing-contact';

class AdminCompanyBillingContact extends Component {
  @tracked editMode = false;
  @tracked newEmail = '';

  constructor() {
    super(...arguments);

    this.newEmail = this.args.companyContact.email;
  }

  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      this.className,
    );
  }

  @action
  editContact() {
    this.editMode = true;
  }

  @action
  editContactCancel() {
    this.editMode = false;

    this.newEmail = this.args.companyContact.email;
  }

  @action
  handleUpdateEmail(value) {
    this.newEmail = value;
  }

  @action
  updateContact(companyContact, newEmail) {
    this.editMode = false;

    this.args.updateBillingContact(companyContact, newEmail);
  }
}

export default AdminCompanyBillingContact;
